"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusVisibleIndicator = exports.ValidFocusIndicator = exports.ErrorFocusIndicator = exports.DefaultFocusIndicator = exports.FocusIndicatorInsetWidth = exports.FocusIndicatorWidth = exports.FocusInsetBorderColors = exports.FocusIndicatorColors = void 0;
var tslib_1 = require("tslib");
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var Colors_1 = require("./Colors");
exports.FocusIndicatorColors = {
    Default: '#0b5cab',
    Invert: '#aacbff',
    Error: Colors_1.TextFieldBorderColors.Error,
    Valid: Colors_1.TextFieldBorderColors.Valid,
};
exports.FocusInsetBorderColors = {
    Default: 'white',
    Invert: '#242424',
};
exports.FocusIndicatorWidth = 2;
exports.FocusIndicatorInsetWidth = 1;
var focusIndicatorStyles = function (color, outlineOffset) {
    if (outlineOffset === void 0) { outlineOffset = -2; }
    return Object.freeze({
        outline: exports.FocusIndicatorWidth + "px solid " + color,
        outlineOffset: outlineOffset,
        $nest: {
            '&::-moz-focus-inner': { $unique: true, border: 'none' }
        }
    });
};
var focusInsetBorderStyles = function (color) { return Object.freeze({
    boxShadow: "inset 0 0 0 " + (exports.FocusIndicatorInsetWidth + 1) + "px " + color, // +1 to account for overlap with outline
}); };
var DefaultFocusIndicator = function (options) { return (tslib_1.__assign(tslib_1.__assign({}, focusIndicatorStyles((options === null || options === void 0 ? void 0 : options.invert) ? exports.FocusIndicatorColors.Invert : exports.FocusIndicatorColors.Default, options === null || options === void 0 ? void 0 : options.outlineOffset)), (options === null || options === void 0 ? void 0 : options.inset) && focusInsetBorderStyles((options === null || options === void 0 ? void 0 : options.invert) ? exports.FocusInsetBorderColors.Invert : exports.FocusInsetBorderColors.Default))); };
exports.DefaultFocusIndicator = DefaultFocusIndicator;
exports.ErrorFocusIndicator = focusIndicatorStyles(exports.FocusIndicatorColors.Error);
exports.ValidFocusIndicator = focusIndicatorStyles(exports.FocusIndicatorColors.Valid);
exports.FocusVisibleIndicator = TypeStyle.style({
    $debugName: 'focus-visible-indicator',
    outline: 'none',
    $nest: {
        '&:focus-visible': exports.DefaultFocusIndicator(),
    }
});
//# sourceMappingURL=FocusIndicators.js.map